import { render, staticRenderFns } from "./TemplatePhaseHeader.vue?vue&type=template&id=aae44fae&"
import script from "./TemplatePhaseHeader.vue?vue&type=script&lang=js&"
export * from "./TemplatePhaseHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports